// REPORTED MESSAGE STATUSES
export const STATUS_CREATED = 'CREATED';
export const STATUS_BLOCKED = 'BLOCKED';
export const STATUS_IGNORED = 'IGNORED';

// REPORT TYPE
export const REPORT_TYPE_USER = 'USER';
